<template>
  <div class="blood-donor">
    <h1 class="hide-wcag">Krwiodawca wielokrotny</h1>
    <Hero :dataProps="data.hero" class="titan-white" />
    <HonoraryDonor :dataProps="data.honorary_donor" />
    <!-- <MobileApp :dataProps="data.mobile_app" /> -->
    <Marrow :dataProps="data.marrow" />
    <Calendar :dataProps="data.calendar" />
    <Video :dataProps="data.video" />
    <Airplane :dataProps="data.airplane" />
  </div>
</template>

<script>
import Vue from 'vue';
import Hero from '@/components/partials/Hero';
import HonoraryDonor from '@/components/blood-donor-multiple/HonoraryDonor';
// import MobileApp from '@/components/blood-donor-multiple/MobileApp';
import Marrow from '@/components/blood-donor-multiple/Marrow';
import Calendar from '@/components/blood-donor-multiple/Calendar';
import Video from '@/components/blood-donor-multiple/Video';
import Airplane from '@/components/blood-donor/Airplane';
import { HTTP } from '@/utils/http-common';
import { dealWithHttpErrors } from '@/mixins/deal-with-http-errors';

export default Vue.extend({
  mixins: [
    dealWithHttpErrors,
  ],
  components: {
    Hero,
    HonoraryDonor,
    // MobileApp,
    Marrow,
    Calendar,
    Video,
    Airplane,
  },
  data() {
    return {
      data: {},
    };
  },
  created() {
    HTTP.get('acf/v3/pages/623').then((response) => {
      this.data = response.data.acf;
    }).catch((e) => {
      this.handleError(e.response);
    });
  },
});
</script>